import { render, staticRenderFns } from "./pacienteSelecionado.vue?vue&type=template&id=05f52c5e"
import script from "./pacienteSelecionado.vue?vue&type=script&lang=js"
export * from "./pacienteSelecionado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports